// src/assets/images/products/getProductImages.js

const images = import.meta.glob('./*.{png,jpg,jpeg,webp}', {
  eager: true,
  import: 'default',
});

const imageMap = Object.fromEntries(
  Object.entries(images).map(([path, mod]) => {
    const fileName = path.split('/').pop(); // e.g., 'product-a.png'
    return [fileName, mod];
  })
);

const getProductImage = (fileName) =>
  imageMap[fileName] || imageMap['imgnotavailable.png'];

export default getProductImage;
